import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select'
import jsPDF from 'jspdf';
import JsBarcode from 'jsbarcode';
import Canvg from 'canvg';

export default {
	name: 'barcode',
	components: {
		BasicSelect,
		VueElementLoading,
		Canvg
	},
	props: [],
	data() {
		return {
			hubid:'',
			hubidLoading:'',
			isLoadingSearch:false,
			checkAll:false,
			hubDetails:[],
			hubItem: {},
      createdby:'',
		}
	},
	computed: {

	},
	filters: {
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.gethubList();
	},
	methods: {

		gethubList() {
			this.hubDetails = [];
			this.hubItem = {};
			this.hubidLoading = 'Searching connection name...';
			this.input = ({});
			axios({
				method: 'GET',

				url: apiUrl.api_url_hubops + 'getBarcodeList?currentHubId=' + this.hubid ,
				data: this.input,
				headers: {
					'Authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.hubDetails = [{
						value: "0",
						text: "Select All"
					}];
					this.hubItem = this.hubDetails[0];

					var hubData = result.data.ResponseData;
					for (var i = 0; i < hubData.length; i++) {
						this.hubDetails.push({
							"text":  hubData[i].connectionname,
							"value": hubData[i].connectionid,
							"text1":hubData[i].barcodedata
						});
					}
				} else {
					this.$alertify.error(result.data.ReturnMessage)
				}
				this.hubidLoading = '';
			}, error => {
				this.hubidLoading='';
				console.error(error)
			})
		},

		selectedhubid(hubItem) {
			this.hubItem = hubItem
		},

		resetForm(){
		 this.selected = '';
		 this.hubDetails = [];
		 this.hubItem = {};
		 this.isLoadingSearch = false;
		 this.gethubList();
		 this.$validator.reset();
	 },

	 async bulkAction(elem){
		this.$validator.validateAll().then(async (result) => {

			if (!result && !this.hubItem.value) {
				return false;
			} else if(elem===0 && this.hubItem.value <=0) {
				this.$alertify.error('Select atleast one HubId!'); return false;
			}

			 this.isLoadingSearch = true;

			 const doc = new jsPDF('p', 'pt', 'a4');
			 doc.setFontSize(25).setFontType("bold")
			 doc.setLineWidth(.5)

			 let o=0; let e=0;

			 if(elem===0){
				 let barcUrl = await this.textToBase64Barcode(this.hubItem.text1);
				 doc.rect(65, (65+o*260), 470, 238)
				 doc.addImage(barcUrl, 'JPEG', 150, (110+o*260), 300, 80)
				 doc.text(140, (240+o*430), this.hubItem.text)

			 }else if(elem===1 && this.hubDetails.length>0){
					this.selectedhubid({
		 				value: "0",
		 				text: "Select All"
		 			});

				 for (var i = 1; i < this.hubDetails.length; i++) {
					let barcUrl = await this.textToBase64Barcode(this.hubDetails[i].text1);

				 	if(o==1 ){ o=0;  doc.addPage(); }
		 				doc.rect(65, (65+o*260), 470, 238)
		 				doc.addImage(barcUrl, 'JPEG', 150, (110+o*260), 300, 80)
						doc.text(140, (240+o*430), this.hubDetails[i].text)
		 				o++;
				 }
			 }
			 doc.save("barcodelist.pdf");
			 this.isLoadingSearch = false;

		 }).catch(() => {
		 	 this.isLoadingSearch = false;
			 console.log('errors exist', this.errors)
		 });
	 },

	 async textToBase64Barcode(text){
		var canvas = document.createElement("canvas");
		JsBarcode(canvas, text, {format: "CODE39", displayValue: false, fontSize:55, textmargin:"0", fontoptions:"bold", height:150});
		return canvas.toDataURL("image/png");
	 },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoHandoverBarcode/AutoHandoverBarcode.js